import { createSlice } from '@reduxjs/toolkit'
import { LatLngExpression, Point } from "leaflet";
import { PayloadAction } from "@reduxjs/toolkit";
import { LeafletPixiApiSettings } from "../../../../../api/pixijs/renderers/OperationRenderer";
import { settings } from "pixi.js";

export interface PixiState extends LeafletPixiApiSettings{
}

const initialState: PixiState = {
    zoom: 15,
    project: () => new Point(0, 0),
    scale : 1
}
const pixiSlice = createSlice({
    name: 'pixiSettingsSlice',
    initialState,
    reducers: {
        setPixiSettings(state: PixiState, action: PayloadAction<LeafletPixiApiSettings>){
            return action.payload
        }
    }
})

export const actions = { ...pixiSlice.actions }
export default pixiSlice.reducer